import { useEffect, useState } from "react";
import { Users, Briefcase, Package, ImageIcon, MessageSquare, MailOpen } from "lucide-react";
import { api } from "@/lib/api";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/dashboard").then(setData); }, []);

  if (!data) return <div className="text-muted-foreground">Cargando...</div>;

  const cards = [
    { label: "Talentos activos", value: data.total_talents, Icon: Users },
    { label: "Servicios activos", value: data.total_services, Icon: Briefcase },
    { label: "Productos", value: data.total_products, Icon: Package },
    { label: "Clientes", value: data.total_clients, Icon: ImageIcon },
    { label: "Leads totales", value: data.total_leads, Icon: MessageSquare },
    { label: "Leads no leídos", value: data.unread_leads, Icon: MailOpen },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-display text-4xl font-black tracking-tighter mb-1">Dashboard</h1>
      <p className="text-sm text-muted-foreground mb-8">Resumen del sitio.</p>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-4 mb-10">
        {cards.map((c) => (
          <div key={c.label} className="border border-border rounded-sm p-5 bg-background">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs uppercase tracking-widest font-bold text-muted-foreground">{c.label}</span>
              <c.Icon className="w-4 h-4 text-primary" />
            </div>
            <div className="font-display text-3xl font-black tracking-tighter">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="border border-border rounded-sm p-6">
          <h3 className="font-display font-bold text-lg mb-4">Últimos leads</h3>
          {data.last_leads?.length ? (
            <ul className="space-y-3">
              {data.last_leads.map((l) => (
                <li key={l.id} className="text-sm flex justify-between border-b border-border pb-2">
                  <span><strong>{l.name}</strong> — {l.interest}</span>
                  <span className="text-muted-foreground text-xs">{new Date(l.created_at).toLocaleDateString()}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-muted-foreground">Sin leads aún.</p>}
        </div>
        <div className="border border-border rounded-sm p-6">
          <h3 className="font-display font-bold text-lg mb-4">Talentos destacados</h3>
          {data.featured_talents?.length ? (
            <ul className="space-y-2">
              {data.featured_talents.map((t) => (
                <li key={t.id} className="text-sm flex justify-between">
                  <span>{t.artist_name}</span><span className="text-muted-foreground text-xs">{t.city}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-sm text-muted-foreground">Sin destacados.</p>}
        </div>
      </div>
    </div>
  );
}
